import { SVGProps } from 'react'

const NotificationIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="1em" height="1em" fill="none" {...props}>
			<path
				d="M7.5 15C7.5 15.663 7.76339 16.2989 8.23223 16.7678C8.70107 17.2366 9.33696 17.5 10 17.5C10.663 17.5 11.2989 17.2366 11.7678 16.7678C12.2366 16.2989 12.5 15.663 12.5 15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M4.3749 8.125C4.3749 6.63316 4.96753 5.20242 6.02243 4.14752C7.07732 3.09263 8.50806 2.5 9.9999 2.5C11.4917 2.5 12.9225 3.09263 13.9774 4.14752C15.0323 5.20242 15.6249 6.63316 15.6249 8.125C15.6249 10.9234 16.2733 13.1719 16.789 14.0625C16.8437 14.1574 16.8726 14.2649 16.8727 14.3745C16.8728 14.484 16.8441 14.5916 16.7895 14.6865C16.7349 14.7815 16.6563 14.8604 16.5616 14.9154C16.4669 14.9705 16.3594 14.9996 16.2499 15H3.7499C3.64051 14.9993 3.53321 14.97 3.43872 14.9149C3.34423 14.8597 3.26587 14.7808 3.21146 14.6859C3.15705 14.591 3.1285 14.4835 3.12866 14.3741C3.12883 14.2647 3.1577 14.1572 3.2124 14.0625C3.72725 13.1719 4.3749 10.9227 4.3749 8.125Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}

export default NotificationIcon
